export const RESIZE_THROTTLE_DELAY = 100;
